var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"height":"100%"}},[_c('v-row',{staticStyle:{"margin-top":"20%"},attrs:{"justify":"center"}},[_c('v-card-subtitle',{staticStyle:{"font-size":"35px","line-height":"35px"},attrs:{"align":"center"}},[_vm._v("Response Submitted Successfully!")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }